/**
 * @generated SignedSource<<8522b0de1f92496745ead0722f5687ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ActivitySource = "CABANA" | "SIPGATE" | "STRIPE" | "ZAMMAD" | "%future added value";
export type CustomerActivityViewQuery$variables = {
  customerAccountIdentifier: string;
  first?: number | null | undefined;
  offset?: number | null | undefined;
};
export type CustomerActivityViewQuery$data = {
  readonly customerAccountActivities: {
    readonly activities: ReadonlyArray<{
      readonly actorName: string | null | undefined;
      readonly body: string | null | undefined;
      readonly id: string;
      readonly metadata: any;
      readonly occurredAt: any;
      readonly source: ActivitySource;
      readonly type: string;
    }>;
    readonly hasMore: boolean;
    readonly totalCount: number;
  };
};
export type CustomerActivityViewQuery = {
  response: CustomerActivityViewQuery$data;
  variables: CustomerActivityViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customerAccountIdentifier"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offset"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "customerAccountIdentifier",
        "variableName": "customerAccountIdentifier"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      }
    ],
    "concreteType": "ActivityResult",
    "kind": "LinkedField",
    "name": "customerAccountActivities",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activities",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "source",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "occurredAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metadata",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actorName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "body",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasMore",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerActivityViewQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomerActivityViewQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e04c788f21d201ba15fcc6f56fb4e15f",
    "id": null,
    "metadata": {},
    "name": "CustomerActivityViewQuery",
    "operationKind": "query",
    "text": "query CustomerActivityViewQuery(\n  $customerAccountIdentifier: ID!\n  $first: Int\n  $offset: Int\n) {\n  customerAccountActivities(customerAccountIdentifier: $customerAccountIdentifier, first: $first, offset: $offset) {\n    activities {\n      id\n      source\n      type\n      occurredAt\n      metadata\n      actorName\n      body\n    }\n    totalCount\n    hasMore\n  }\n}\n"
  }
};
})();

(node as any).hash = "54321a5191169475851ae068dd436a05";

export default node;
